import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=b9b2f102&"
import script from "./SalesReport.vue?vue&type=script&lang=ts&"
export * from "./SalesReport.vue?vue&type=script&lang=ts&"
import style0 from "./SalesReport.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports